import { render, staticRenderFns } from "./chatReminderNotice.vue?vue&type=template&id=482e01b7&scoped=true"
import script from "./chatReminderNotice.vue?vue&type=script&lang=js"
export * from "./chatReminderNotice.vue?vue&type=script&lang=js"
import style0 from "./chatReminderNotice.vue?vue&type=style&index=0&id=482e01b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e01b7",
  null
  
)

export default component.exports